<template>
  <!-- Kit CountPill (MacMain's sidebar counts): a quiet tabular count, or
       the violet badge. Hidden when unknown, empty or 0. -->
  <span v-if="shown" class="count-pill" :class="{ 'is-badge': badge }">{{ text }}</span>
</template>

<script>
export default {
  name: "CountPill",
  props: {
    value: { type: [Number, String], default: null },
    badge: { type: Boolean, default: false },
  },
  computed: {
    number() {
      const n = Number(this.value);
      return Number.isFinite(n) ? n : null;
    },
    shown() {
      return this.number != null && this.number > 0;
    },
    text() {
      return this.number > 999 ? `${Math.floor(this.number / 1000)}k` : String(this.number);
    },
  },
};
</script>

<style scoped>
.count-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: transparent;
  color: var(--cl-label-3);
  font: 600 11px/1 var(--cl-font);
  font-variant-numeric: tabular-nums;
  box-sizing: border-box;
}
.count-pill.is-badge {
  background: var(--cl-accent);
  color: var(--cl-on-fill);
}
</style>
